var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ManagementPage", {
        attrs: { pageName: _vm.$t("External") + " / " + _vm.$tc("Map", 2) },
        scopedSlots: _vm._u([
          {
            key: "left",
            fn: function() {
              return [
                _c("TableView", {
                  attrs: {
                    selectedObjectID: _vm.selectedMap
                      ? _vm.selectedMap.id
                      : null
                  },
                  on: {
                    "open-create-map-form": function($event) {
                      _vm.isThirdPartyDialogOpen = true
                    },
                    "clear-selected-item": function($event) {
                      _vm.selectedMap = null
                    }
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "right",
            fn: function() {
              return [
                _c("Map", {
                  attrs: { selectedMap: _vm.selectedMap },
                  on: {
                    "clear-selected-item": function($event) {
                      _vm.selectedMap = null
                    }
                  }
                }),
                _vm._v(" "),
                _c("ThirdPartyDialog", {
                  attrs: { isOpen: _vm.isThirdPartyDialogOpen },
                  on: {
                    createMap: function($event) {
                      _vm.selectedMap = {}
                      _vm.isThirdPartyDialogOpen = false
                    },
                    cancelMap: function($event) {
                      _vm.isThirdPartyDialogOpen = false
                    }
                  }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("dialog-choice", {
        attrs: {
          isOpen: _vm.discardChangesDialogIsOpen,
          title: _vm.$t("DiscardChanges"),
          content: _vm.$t("ClusterCreationConfirmation"),
          mainActionLabel: _vm.$t("Confirm"),
          secondaryActionLabel: _vm.$t("Cancel"),
          icon: "mdi-delete",
          iconColor: "var(--app-primary-base)"
        },
        on: {
          mainAction: _vm.confirmDiscardChanges,
          secondaryAction: function($event) {
            _vm.discardChangesDialogIsOpen = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a98253d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a98253d4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/MapsView.vue
// module id = null
// module chunks = 